import { useRef, useState, useEffect } from 'react'
import NavElement from '../NavElement'
import { pages } from '../data'
import { LastPageReveal } from './LastPageReveal'
import { SwipeHint } from './SwipeHint'

export function Viewpager() {
  // Native scroll-snap container with per-page progress computed from scrollLeft
  const containerRef = useRef(null)
  // Initialize: first page centered (0), others off-screen (±1)
  const [progressList, setProgressList] = useState(() => pages.map((_, i) => (i === 0 ? 0 : 1)))

  const scrollToIndex = (i) => {
    const el = containerRef.current
    if (!el) return
    const vw = el.clientWidth
    el.scrollTo({ left: i * vw, behavior: 'smooth' })
  }

  // Recompute progress for each page based on container scroll
  const computeProgress = () => {
    const el = containerRef.current
    if (!el) return
    const vw = el.clientWidth
    const center = el.scrollLeft + vw / 2

    const next = pages.map((_, i) => {
      const pageCenter = i * vw + vw / 2
      // distance in viewport widths; 0 = centered, -1 = one page to the left, +1 = one page to the right
      let p = (pageCenter - center) / vw
      // clamp to [-1, 1] so styles map cleanly
      if (p < -1) p = -1
      if (p > 1) p = 1
      return p
    })
    setProgressList(next)
  }

  // rAF throttle for scroll handler
  const rAF = useRef(0)
  const onScroll = () => {
    if (rAF.current) return
    rAF.current = requestAnimationFrame(() => {
      rAF.current = 0
      computeProgress()
    })
  }

  useEffect(() => {
    computeProgress()
    const onResize = () => computeProgress()
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return (
    <div className="fade-in container" ref={containerRef} onScroll={onScroll}>
      {pages.map((page, i) => {
        const p = progressList[i] ?? 1
        const isLastCentered = page.last && Math.abs(p) < 0.02
        return (
          <div key={page.key} className="page" style={{ position: 'relative' }}>
            {!page.last && <NavElement page={page} progress={p} onGoto={scrollToIndex} />}
            {page.last && <LastPageReveal isActive={!!isLastCentered} text={page.text || ''} />}
          </div>
        )
      })}
      {/* New SwipeHint component */}
      <SwipeHint />
    </div>
  )
}
